import axios from 'axios'
import { Message } from 'element-ui'
import http from '../../../utils/http'

const getApiConfig = function (requestConfig) {

  return function (query) {

    if(requestConfig.method === 'get'){
      requestConfig.params = query
    }else{
      requestConfig.data = query
    }

    return new Promise ((resolve, reject) => {
      http.axiosInstance(requestConfig).then(res => {
        if('resultCode' in res.data && res.data.resultCode !== 0){
          resolve({data: []})
        }else{
          resolve(res.data)
        }
      }, () => {
        Message.error('基础数据组件网络异常')
        reject()
      })
    })
  }
}

export default getApiConfig
